/**
 * @description 分享图片浮层
 */
const shareSource = {
  shareWeixinUser: {
    url: 'https://puui.qpic.cn/vupload/0/20190715_1563192194718_ngkvd4xqy7k.png/0',
    text: '微信好友',
  },
  shareWeixinTimeline: {
    url: 'https://puui.qpic.cn/vupload/0/20190715_1563192178270_flmbmn67tx.png/0',
    text: '朋友圈',
  },
  shareQQUser: {
    url: 'https://puui.qpic.cn/vupload/0/20190715_1563192191002_4x1autbnalf.png/0',
    text: 'QQ好友',
  },
  shareQzone: {
    url: 'https://puui.qpic.cn/vupload/0/20190715_1563192183217_sexdvc5v2dd.png/0',
    text: 'QQ空间',
  },
  shareSinaWeibo: {
    url: 'https://puui.qpic.cn/vupload/0/20190715_1563192201086_9tpy6y87c34.png/0',
    text: '新浪微博',
  },
};
const defaultShareOptions = [
  'shareWeixinUser',
  'shareWeixinTimeline',
  'shareQQUser',
  'shareQzone',
  'shareSinaWeibo',
];
const shareStyle = `
    .iv-txv-preview-share-image {
      position: fixed;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      background: rgba(0,0,0,0.8);
    }
    .iv-txv-preview-share-image .image {
      position: absolute;
      object-fit: contain;
      width: 60vw;
      height: 60vh;
      left: 50%;
      top: 10vh;
      transform: translateX(-50%);
    }
    .iv-txv-preview-share-image .share-bar {
      position: absolute;
      bottom: 10%;
      width: 100%;
      padding: 0 10%;
      box-sizing: border-box;
      text-align: center;
    }
    .iv-txv-preview-share-image .share-bar .share-item {
      margin: 0 20px;
      display: inline-block;
      width: 50px;
      height: 50px; 
      border-radius: 50%; 
      background: rgba(0,0,0, 0.6); 
      text-align: center;
    }
    .iv-txv-preview-share-image .share-bar .share-text {
      font-size: 10px;
      color: #ffffff;
    }
    .iv-txv-preview-share-image .share-bar img {
      border-radius: 50%; 
      border: none;
    }
    .iv-txv-preview-share-image .close-btn {
      position: absolute;
      left: 30px;
      top: 20px;
      width: 40px;
      height: 40px;
      z-index: 100000;
      background-size: cover;
      background-image: url(https://puui.qpic.cn/vupload/0/1567069102477_m58qz2c23qo.png/0);
    }
    
    @media (orientation: portrait) {
      .iv-txv-preview-share-image .close-btn {
        right: 20px;
        left: initial;
      }
      .iv-txv-preview-share-image .image {
        width: 100vw;
        height: calc(100vw * 9 / 16);
        top: 30%;
        left: 0;
        transform: translateY(-30%);
      }
      .iv-txv-preview-share-image .share-bar {
        bottom: 20%;
        padding: 0;
      }
      .iv-txv-preview-share-image .share-bar .share-item {
        margin: 0 6px;
      }
    }
  `;

export default async function previewShareImage(conf: {
  image: string; // 需要分享的图片
  options?: any; // 分享选项
}): Promise<string> {
  return new Promise((resolve) => {
    const options = conf.options || defaultShareOptions;
    if (!document.querySelector('#__bridge_helper_style')) {
      const style = document.createElement('style');
      style.textContent = shareStyle;
      style.type = 'text/css';
      style.id = '__bridge_helper_style';
      document.head.appendChild(style);
    }
    const el = document.createElement('div');
    el.classList.add('iv-txv-preview-share-image');
    document.body.appendChild(el);
    if (conf.image) {
      const image = document.createElement('img');
      image.classList.add('image');
      image.src = conf.image;
      el.appendChild(image);
    }
    const shareBar = document.createElement('div');
    shareBar.classList.add('share-bar');
    const html: Array<string> = [];
    options.forEach((source: keyof typeof shareSource) => {
      html.push(`<div class="share-item" data-source="${source}">
          <img class="share-icon" data-source="${source}" width="50" height="50" src="${shareSource[source].url}">
          <div class="share-text" data-source="${source}">${shareSource[source].text}</div>
        </div>`);
    });
    const closeBtn = document.createElement('div');
    closeBtn.classList.add('close-btn');
    el.appendChild(closeBtn);
    const onClick = (event: TouchEvent | MouseEvent) => {
      const { target } = event;
      const { source } = (target as HTMLElement).dataset;
      shareBar.removeEventListener('click', onClick);
      closeBtn.removeEventListener('click', onClose);
      el.remove();
      resolve(source);
    };
    const onClose = () => {
      shareBar.removeEventListener('click', onClick);
      closeBtn.removeEventListener('click', onClose);
      el.remove();
      resolve('');
    };
    shareBar.addEventListener('click', onClick);
    shareBar.innerHTML = html.join('');
    el.appendChild(shareBar);
    closeBtn.addEventListener('click', onClose);
  });
}
